import { createReducer } from "@reduxjs/toolkit";

import {
  bonusInitFailure,
  bonusInitRequest,
  bonusInitSuccess,
  collectBonusRequest,
  collectBonusSuccess,
  collectedBonusEvent,
} from "./bonusActions";

type BonusState = {
  timer?: "00:00:00";
  loaded: boolean;
  bonusReady?: false;
  bonus?: any;
  loading: boolean;
  error?: string;
  collecting: boolean;

  daily?: [];
};
const initial: BonusState = { loading: false, loaded: false, collecting: false, } ;

export const bonusReducer = createReducer(initial, (b) => {
  b.addCase(bonusInitRequest, (s) => {
    s.loading = true;
    s.error = undefined;
  });

 b.addCase(bonusInitSuccess, (s, a) => {
    s.loading = false;
    s.loaded = true;
    s.bonus = {
      ...s.bonus,
      ...a.payload.bonus,
    };
  });

  b.addCase(bonusInitFailure, (s, a) => {
    s.loading = false;
    s.error = a.payload;
  });

   b.addCase(collectBonusRequest, (s) => {
    s.collecting = true;
    s.error = undefined;
  });

b.addCase(collectBonusSuccess, (s, a) => {
  s.collecting = false;
 
});

  b.addCase(collectedBonusEvent, (s) => {});
});
